<template>
    <div v-show="visible">
        <el-dialog title="回退到填报" 
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            v-loading="loading"
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" label-width="120px">
             
                <el-input style="margin-top:5px;"
                    type="textarea"
                    placeholder="请输入退回原因"
                    v-model="form.remark"
                    maxlength="300"
                    rows="3"
                    show-word-limit>
                </el-input>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="save()">确定回退</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    remark:"",
                },
                loading:false,
                loadingText:"",
            }
        },
        components: {
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id; 
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        
                        if(this.form.remark == ''){
                            this.$commonFn.showTip('退回原因不可为空',3);
                            return;
                        }
                        
                        this.loading=true;
                        this.loadingText="提交中...";

                        let url= this.teacherAssessBackUrl;
                        let data = {
                            id:this.form.id,
                            remark:this.form.remark
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/teacherAssess/Back.vue